import axios, { AxiosError } from 'axios';
import { IErrorResponse } from '../interfaces/errorResponse';
import { TEXTS } from '../core/texts';
import { ADMIN_BASE_URL } from '../core/paths';

const createAxiosInstance = (baseUrl: string) => axios.create({
  withCredentials: true,
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json'
  },
});

export const axiosAdmin = createAxiosInstance(ADMIN_BASE_URL);


export function parseAxiosError(err: Error | AxiosError<IErrorResponse>): string {
  if(axios.isAxiosError(err)){ return  err.response?.data.message || err.message}
  return err.message;
}

export function axiosErrorHandler(cb: (err: AxiosError<IErrorResponse>) => void, alternativeCb?: (text: string) => void) {
  return (error: Error | AxiosError<IErrorResponse>) => {
    if(axios.isAxiosError(error)) {
      cb(error);
      return;
    }
    // Alternative cb is used if for some reason the response is different from AxiosResponse.
    if(alternativeCb) {
      alternativeCb(error.message || TEXTS.SOMETHING_WENT_WRONG);
      return;
    }};
}

export function handleAxiosErrorMessage(cb: (msg: string) => void) {
  return axiosErrorHandler((err) => 
      cb(err.response?.data.message || err.message), 
    (err) => cb(err)
  );
}
